/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled, { css } from 'styled-components';
import { isNil } from 'lodash-es';
import { colors } from '../../utils/colors';
import { getDownMedia } from '../../styles';
import { TableCell } from './TableCell';
import { commonNumbersAligning } from './common';

export const ChangeCell = styled(TableCell)<{
  $positiveChange?: boolean;
  $jadeGreenColor?: boolean;
}>`
  ${commonNumbersAligning};
  width: 13.517%;
  min-width: 78px;
  color: inherit;

  ${getDownMedia('sm')} {
    min-width: 80px;
  }

  ${({ $positiveChange, $jadeGreenColor }) => {
    if (isNil($positiveChange)) return null;

    return css`
      color: ${$positiveChange
        ? colors[$jadeGreenColor ? 'jade' : 'green']
        : colors.red};
    `;
  }}
`;
